import { render, staticRenderFns } from "./dashboard_card.vue?vue&type=template&id=5adbc692&scoped=true&"
import script from "./dashboard_card.vue?vue&type=script&lang=js&"
export * from "./dashboard_card.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_card.vue?vue&type=style&index=0&id=5adbc692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adbc692",
  null
  
)

export default component.exports